import { FormControlLabel, Switch } from '@mui/material';
import { cn } from 'cn';

import { useFieldContext } from './form-context';

type P = {
  readonly label: string;
  readonly onChange?: (checked: boolean) => void;
  readonly testId?: string;
} & ComponentStyling;

export const SwitchField = ({
  className,
  label,
  onChange,
  style,
  testId,
}: P) => {
  const field = useFieldContext();

  return (
    <div className={cn('relative', className)} style={style}>
      <FormControlLabel
        className="text-tiga-text-default [&>span]:text-sm [&>span]:select-none"
        control={
          <Switch
            aria-pressed={Boolean(field.state.value)}
            checked={Boolean(field.state.value)}
            data-testid={testId}
            onChange={(event) => {
              const checked = event.target.checked;
              field.handleChange(checked);
              onChange?.(checked);
            }}
          />
        }
        label={label}
      />
    </div>
  );
};
